import SubordinateManagement from "../pages/AdministrationCenter/SubordinateManagement";
import TradeRecord from "../pages/AdministrationCenter/TradeRecord";
import ApplicationRejected from "../pages/Agent/ApplicationRejected";
import Apply from "../pages/Agent/Apply";
import Balance from "../pages/Balance";
import BetInquiry from "../pages/BetInquiry";
import Blocked from "../pages/Blocked";
import Event from "../pages/Event";
import Help from "../pages/Help";
import Home from "../pages/Home";
import Personal from "../pages/Personal";
import Profile from "../pages/Profile";
import Promote from "../pages/Promote";
import ComissionReport from "../pages/ReportManagement/ComissionReport";
import DownlineReport from "../pages/ReportManagement/DownlineReport";
import FinancialReport from "../pages/ReportManagement/FinancialReport";
import HandlingFeeReport from "../pages/ReportManagement/HandlingFeeReport";
import ProductReport from "../pages/ReportManagement/ProductReport";
import SystemAnnouncement from "../pages/SystemAnnouncement";
// import Test from "../pages/Test";

const RouterList = [
  {
    path: "/home",
    name: "home",
    component: Home,
    navType: {
      hideHeader: true,
      hideFooter: false,
      background: "var(--background)",
      // left: {
      //   type: "user",
      // },
      // center: {},
      // right: { type: "user" },
    },
  },
  {
    path: "/",
    name: "apply",
    component: Apply,
    navType: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/blocked",
    name: "blocked",
    component: Blocked,
    navType: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/apply/rejected",
    name: "rejected",
    component: ApplicationRejected,
    navType: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/member",
    name: "subordinateManagement",
    component: SubordinateManagement,
    navType: {
      hideFooter: false,
      backArrow: false,
      title: "mobile.page.title.member",
    },
  },
  {
    path: "/promote",
    name: "promote",
    component: Promote,
    navType: {
      hideFooter: false,
      backArrow: false,
      title: "mobile.page.title.promote",
      hideCurrencyCahnger: true,
    },
  },

  {
    path: "/downline",
    name: "downline",
    component: DownlineReport,
    navType: {
      hideFooter: false,
      title: "mobile.home.menu.downline",
    },
  },

  {
    path: "/financial",
    name: "financial",
    component: FinancialReport,
    navType: {
      hideFooter: false,
      title: "mobile.home.menu.financial",
    },
  },
  {
    path: "/commission",
    name: "commission",
    component: ComissionReport,
    navType: {
      hideFooter: false,
      backArrow: false,
      title: "mobile.page.title.comission",
    },
  },
  {
    path: "/handlingfee",
    name: "handlingfee",
    component: HandlingFeeReport,
    navType: {
      hideHeader: false,
      hideFooter: true,
      title: "mobile.handlingFeeReport.title",
    },
  },
  {
    path: "/transaction",
    name: "tradeRecord",
    component: TradeRecord,
    navType: {
      hideFooter: true,
      title: "mobile.home.menu.transaction",
    },
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: Test,
  //   navType: {
  //     hideHeader: false,
  //     hideFooter: false,
  //     background: "var(--background)",
  //     backUrl: "/home",
  //     title: "month.05",
  //   },
  // },
  {
    path: "/personal/event",
    name: "event",
    component: Event,
    navType: {
      hideHeader: true,
      hideFooter: true,
      backUrl: "/personal",
    },
  },
  {
    path: "/personal/help",
    name: "help",
    component: Help,
    navType: {
      hideHeader: false,
      hideFooter: true,
      hideCurrencyCahnger: true,
      title: "menu.personal.help",
      backUrl: "/personal",
    },
  },
  {
    path: "/personal/announcement",
    name: "announcement",
    component: SystemAnnouncement,
    navType: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/personal",
    name: "personal",
    component: Personal,
    navType: {
      hideHeader: true,
      hideFooter: false,
      backgroundImg: "/images/personal/bg.png",
    },
  },
  {
    path: "/balance",
    name: "balance",
    component: Balance,
    navType: {
      hideHeader: false,
      hideFooter: true,
      hideCurrencyCahnger: true,
      title: "menu.personal.balance",
      backUrl: "/personal",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    navType: {
      hideHeader: false,
      hideFooter: true,
      hideCurrencyCahnger: true,
      title: "menu.personal.personalInfo",
      backUrl: "/personal",
    },
  },
  {
    path: "/product",
    name: "product",
    component: ProductReport,
    navType: {
      hideHeader: false,
      hideFooter: true,
      title: "mobile.productReport.title",
      backUrl: "/home",
    },
  },
  //for homepage
  {
    path: "/home/help",
    name: "help",
    component: Help,
    navType: {
      hideHeader: false,
      hideFooter: true,
      hideCurrencyCahnger: true,
      title: "menu.personal.help",
      backUrl: "/home",
    },
  },
  {
    path: "/home/event",
    name: "event",
    component: Event,
    navType: {
      hideHeader: true,
      hideFooter: true,
      backUrl: "/home",
    },
  },
  {
    path: "/home/announcement",
    name: "announcement",
    component: SystemAnnouncement,
    navType: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/betinquiry",
    name: "betinquiry",
    component: BetInquiry,
    navType: {
      hideFooter: true,
      title: "mobile.menu.betInquiry",
      backUrl: "/home",
    },
  },
];
export default RouterList;
